import React, { Component } from "react";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import QuestionnaireForm from "../Pages/QuestionerPage.jsx"

import { fetchAnswer } from "../../api/answer";

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { withRouter } from "react-router-dom";

const options = {
  chart: {
    type: 'spline'
  },
  title: {
    text: 'My chart'
  },
  series: [
    {
      data: [1, 2, 1, 4, 3, 6]
    }
  ]
};

class Userstatistic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      score1: 0,
      score2: 0
    };
  }
  componentDidMount() {
    fetchAnswer()
      .then(response => {
        let score1 = 0;
        let score2 = 0;
        response.data.results.map(e => {
          console.log(e.score1);
          score1 = score1 + e.score1;
          score2 = score2 + e.score2;
        });

        score1 = (score1 / response.data.count);
        score2 = (score2 / response.data.count);

        this.setState({
          score1: score1.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
          score2: score2.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
        });
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });
  }

  renderScore = () => {
    if (localStorage.getItem("email") == "admin@sibernetik.co.id") {
      return (
        <GridItem xs={12}>
          <GridItem xs={6}>
            <Card>
              <CardBody>
                Question Options Avarage Score <h1>{this.state.score1} </h1> high score 10
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={6}>
            <Card>
              <CardBody>
                Question True False Avarage Score <h1>{this.state.score2}</h1> high score 10
              </CardBody>
            </Card>
          </GridItem>
        </GridItem>
      );
    } else {
      return "";
    }
  };
  render() {
    return (
      <GridContainer>
        {this.renderScore()}
        <GridItem xs={12}>
          <QuestionnaireForm />
        </GridItem>
      </GridContainer>
    );
  }
}

export default withRouter(Userstatistic);
